import React from "react";
import { BaseComponent } from "@reapptor-apps/reapptor-react-common";
import {
    Button,
    Modal,
} from "@reapptor-apps/reapptor-react-components";
import { Justify } from "@reapptor-apps/reapptor-react-common";
import FenixAppController from "@/pages/FenixAppController";
import Localizer from "@/localization/Localizer";
import styles from "./ReservationGuideModal.module.scss";

const reservationOptions = [
    "privateIndividual",
    "occupationalHealth",
    "kela65"
] as const;
type IReservationOption = typeof reservationOptions[number];

export default class ReservationGuideModal extends BaseComponent {
    private readonly _modalRef: React.RefObject<Modal> = React.createRef();
    
    private get modal(): Modal {
        return this._modalRef.current!;
    }
    
    public async closeAsync(): Promise<void> {
        if (this.modal) {
            await this.modal.closeAsync();
        }
    }
    
    public async openAsync(): Promise<void> {
        if (this._modalRef.current) {
            await this._modalRef.current.openAsync();
        }
    }

    private handleSelection(selectedOption: IReservationOption) {
        return async () => {
            switch(selectedOption) {
                case "privateIndividual":
                    // No action
                    break;
                case "occupationalHealth":
                    await FenixAppController.openOccupationalAppointments();
                    break;
                case "kela65":
                    await FenixAppController.openKela65Appointments();
                    break;
            }
            
            await this.closeAsync();
        }
    }
    
    private get getTitle() {
        return Localizer.reservationGuideModalTitle;
    }

    public render(): React.ReactNode {
        return (
            <Modal
                id={"reservation-guide-modal"}
                ref={this._modalRef}
                title={this.getTitle}
                onClose={this.closeAsync}
                className={styles.reservationGuideModal}
            >
                <div className={styles.optionsContainer}>
                    <Button 
                        onClick={this.handleSelection("privateIndividual")} 
                        icon={{ name: "fa-angle-right" }} 
                        iconPosition={Justify.Right} 
                        label={Localizer.reservationGuideModalOptionsPrivateIndividual} 
                    />
                    <Button
                        onClick={this.handleSelection("occupationalHealth")}
                        icon={{ name: "fa-angle-right" }}
                        iconPosition={Justify.Right}
                        label={Localizer.reservationGuideModalOptionsOccupationalHealth}
                    />
                    <Button
                        onClick={this.handleSelection("kela65")}
                        icon={{ name: "fa-angle-right" }}
                        iconPosition={Justify.Right}
                        label={Localizer.reservationGuideModalOptionsKela65}
                    />
                </div>
            </Modal>
        );
    }
}